import { TFunction } from '@lyearn/i18n';
import {
  adaptFormDataFunction,
  parseFormDataFunction,
} from '@/modules/corporate/modules/database/fields/types';

import { CheckboxValue } from './Cell';

export const adaptFormData: adaptFormDataFunction = (data) =>
  data?.value === CheckboxValue.Yes ? true : false;

export const parseFormData: parseFormDataFunction = (data) => ({
  value: data ? CheckboxValue.Yes : CheckboxValue.No,
});

export const getSelectOptions = (t: TFunction) => [
  { value: CheckboxValue.Yes, label: t('Database:On') },
  { value: CheckboxValue.No, label: t('Database:Off') },
];
